import { Moment } from "moment";
import { FormControl } from "@angular/forms";

export class Attributes {
  typeName: string;
  attribute: { name: string, value: string }[];

  constructor(typeName: string, attribute: { name: string, value: string }[]) {
    this.typeName = typeName;
    this.attribute = attribute;
  }
}



export class SelectPossibleOption {
  key: string;
  value: string;

  constructor(key: string, value?: string) {
    this.key = key;
    this.value = value;
  }
}


export class SearchTag {
  display: string;
  value: string | number;

  constructor(display: string, key: string | number) {
    this.display = display;
    this.value = key;
  }
}

export class SearchTagCheckbox {
  display: string;
  value: string | number;
  checked: boolean;

  constructor(display: string, value: string | number, checked?: boolean) {
    this.display = display;
    this.value = value;
    this.checked = checked ? checked : false;
  }
}

export class AdminSearch {
  annotateSearch: boolean;
  damageSearch: boolean;
  hd: { hd: boolean, nHd: boolean };
  xhd: { xhd: boolean, nxHd: boolean };
  note: { note: boolean, nNote: boolean };
  searchTags: SearchTag[];
  limit: number;
  probalityDamage: { min: number, max: number };
  attributes: any;
  searchTagList: {
    // Annotation filter
    typeTag: SearchTagCheckbox[],
    nTypeTag: SearchTagCheckbox[],

    classTag: SearchTagCheckbox[],
    nClassTag: SearchTagCheckbox[],

    vehiclePartTag: SearchTagCheckbox[],
    nVehiclePartTag: SearchTagCheckbox[],

    classDetectTag: SearchTagCheckbox[],
    nClassDetectTag: SearchTagCheckbox[],

    attributesTag: SearchTagCheckbox[],
    nAttributesTag: SearchTagCheckbox[],

    userAnnotateTag: SearchTagCheckbox[],
    nUserAnnotateTag: SearchTagCheckbox[],

    // Damage filter
    damageTag: SearchTagCheckbox[],
    nDamageTag: SearchTagCheckbox[],

    editDamageTag: SearchTagCheckbox[],
    nEditDamageTag: SearchTagCheckbox[],

  }
}

export class TchekStatus {
  key: string;
  value: string;
  constructor(id: string, name: string) {
    this.key = id;
    this.value = name;
  }
}

export class Device {
  id: string;
  name: string;
  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}

export class FinderData {
  admin: AdminSearch;
  date: { start: Moment, end: Moment };
  sDate: { start: Date, end: Date }
  searchTags: SearchTag[];
  activeFilters: SearchTag[];
  limit: number;
  skip: number;
  isPicturesHD: boolean;
  isPicturesXHD: boolean;
  scanAnnotated: boolean;
  scanAnalyzed: boolean;
  scanForValidation: boolean;
  isDateActive: boolean;
  isDownloaded: boolean;
  minProbVehicle: number; // not used -1
  statusSelect: string;
  deviceSelect: string;
}


// WEBPACK FOOTER //
// ./src/app/model/search.ts